// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ArtController from "./art_controller"
application.register("art", ArtController)

import UploadController from "./upload_controller"
application.register("upload", UploadController)

import HelpSheepController from "./help_sheep_controller"
application.register("help-sheep", HelpSheepController)

import FlockFilterController from "./flock_filter_controller"
application.register("flock-filter", FlockFilterController)

import UsageTrackingController from "./usage_tracking_controller"
application.register("usage-tracking", UsageTrackingController)

import AnimaticReviewController from "./animatic_review_controller"
application.register("animatic-review", AnimaticReviewController)

import CommentRailController from "./comment_rail_controller"
application.register("comment-rail", CommentRailController)

import StudioHeaderController from "./studio_header_controller"
application.register("studio-header", StudioHeaderController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import CopyTextController from "./copy_text_controller"
application.register("copy-text", CopyTextController)

import VideoComparisonController from "./video_comparison_controller"
application.register("video-comparison", VideoComparisonController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)
